<div class="inicio">
        
    <p class="titulo">
        SOLICITUD ASIGNACIÓN DE EQUIPO
        <button mat-mini-fab color="primary" matTooltip="Click para más información" (click)="clickMasInformacion($event)" >
            <mat-icon>info</mat-icon> 
        </button>
    </p>

    <div class="grid-container5">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <p class="label3">Campos obligatorios *</p>
    </div>

    <div class="div">

        
        <div class="grid-container">
        <div class="celda">
            <mat-label class="label">Nombre del empleado<mat-label class="label3">*</mat-label> </mat-label>
            <mat-form-field appearance="outline">
                <mat-select [formControl]="colaborador" #singleSelect1 (selectionChange)="clickCargarDatosColaborador($event)">
                <mat-option>
                    <ngx-mat-select-search [formControl]="input_colaborador" oninput="this.value = this.value.toUpperCase()"></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let option of listaFiltradaColaboradores | async" [value]="option"> 
                    {{option.nomb_compl}} 
                </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        </div>


        <div class="grid-container2">

            <div class="celda">
                <mat-label class="label"> Cargo </mat-label>
                <mat-form-field appearance="outline">
                    <input matInput [disabled]="true" [formControl]="cargo">
                </mat-form-field>
            </div>

            <div class="celda">
                <mat-label class="label"> Oficina </mat-label>
                <mat-form-field appearance="outline">
                    <input matInput [disabled]="true" [formControl]="sucursal">
                </mat-form-field>
            </div>

        </div>

        


        <div class="grid-container2">
            

            <div class="celda">                

                <div class="celda">
                    <mat-label class="label">Tipo de equipo a solicitar <mat-label class="label3">*</mat-label> </mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Selecciona el tipo de activo a solicitar" [formControl]="equipo_solicitado" (selectionChange)="clickSelectTipoEquipo($event)">
                            <mat-option *ngFor="let activo of listaactivos" [value]=activo>{{ activo }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="celda" *ngIf="clickDispositivos()">
                    <mat-label class="label">Especifique el tipo de dispositivo</mat-label>
                    <mat-form-field appearance="outline">
                        <mat-select placeholder="Selecciona una opción a solicitar" [formControl]="tipo_dispositivo" (selectionChange)="tipoDeDispositivoSeleccioando($event)">
                            <mat-option *ngFor="let tipo of listaTipos" [value]=tipo.name>{{ tipo.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="celda">
                    <mat-label class="label">Fecha límite para la asignación<mat-label class="label3">*</mat-label></mat-label>
                    <mat-form-field appearance="outline">
                        <input matInput [matDatepicker]="picker" [formControl]="fecha_planeada_asignacion" [min]="fechaMin">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

            </div>


            <div class="celda" >

                <mat-label class="label"> Especifique el tipo de equipo o describa el uso planeado para el equipo solicitado <mat-label class="label3">*</mat-label></mat-label>
                <mat-form-field class="example-form-field" appearance="outline">
                    <textarea matInput type="text"  style="width: 100%; height: 114px;" placeholder="Ej: Necesito una impresora para cheques" [formControl]="descripcion" oninput="this.value = this.value.toUpperCase()"></textarea>
                </mat-form-field>
            </div>

        </div>


        <div class="grid-container">
            <div class="celda">
                <mat-label class="label">Comentarios</mat-label>
                <mat-form-field class="example-full-width" appearance="outline">
                    <textarea matInput placeholder="Ejem. es el segundo equipo que se le solicita en un periodo corto de tiempo" [formControl]="observaciones" oninput="this.value = this.value.toUpperCase()"></textarea>
                </mat-form-field>
            </div>
        </div>

        <div class="grid-container2">
            <button  type="submit" mat-raised-button color="primary" [disabled]="!habilitarBotonSolicitar()" (click)="clickEnviarSolicitud()" matTooltip="Enviar y guardar la solicitud">Guardar<mat-icon>save</mat-icon></button>
            <button  mat-raised-button color="warn" (click)="clickGoBack($event)" matTooltip="Salir y no guardar esta solicitud" >Cancelar<mat-icon>cancel</mat-icon></button>
        </div>

    </div>

</div>